'use es6';

import formatSurveyMonkeySurvey from '../formatters/formatSurveyMonkeySurvey';
import formatSurveyMonkeyQuestionResponse from '../formatters/formatSurveyMonkeyQuestionResponse';
import http from 'hub-http/clients/apiClient';
import formatSettings from '../formatters/formatSettings';

// https://git.hubteam.com/HubSpot/SurveyMonkey/blob/8ea885ee8ca4bfffba340c12452be07688a17078/SurveyMonkeyService/src/main/java/com/hubspot/surveymonkey/service/resources/SurveysResource.java
const baseUrl = 'surveymonkey/v1/surveys';
export const createGetSurveys = ({
  httpClient
}) => () => httpClient.get(baseUrl, {
  timeout: 60000
}).then(formatSurveyMonkeySurvey);
export const getSurveys = createGetSurveys({
  httpClient: http
});
export const createGetSurveyQuestions = ({
  httpClient
}) => () => httpClient.get(`${baseUrl}/questions?syncEnabled=true`).then(formatSurveyMonkeyQuestionResponse);
export const getSurveyQuestions = createGetSurveyQuestions({
  httpClient: http
});
export const createGetSettings = ({
  httpClient
}) => () => httpClient.get('surveymonkey/v1/settings').then(formatSettings);
export const getSettings = createGetSettings({
  httpClient: http
});